import { TextBlock, Text } from 'bench-internal-theme';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';

export const PersonalTransactionsViewContentArea = styled.div`
  padding: 32px;
`;

export const PersonalLedgerTitle = styled(TextBlock).attrs(() => ({
  styleType: 'title',
}))``;

export const PersonalLedgerHeader = styled(TextBlock).attrs(() => ({
  styleType: 'largeBold',
}))`
  padding-top: 1em;
`;

export const PersonalLedgerDescription = styled(TextBlock).attrs(() => ({
  color: colors.smoke,
  styleType: 'medium',
}))`
  max-width: 75%;
  padding-top: 0.5em;
`;

export const PersonalLedgerCount = styled(Text).attrs(() => ({
  color: colors.smoke,
  styleType: 'mediumBold',
}))`
  margin-left: 0.5em;
`;

export const PersonalLedgerContainer = styled.div`
  padding-top: 2em;
  display: flex;
  flex-direction: column;
`;

export const PersonalLedgerTableHeader = styled.div`
  display: grid;
  border-bottom: 1px solid ${colors.silt};
  grid-template-columns: 70% 30%;
  padding: 1em;
`;

export const PersonalLedgerTableHeaderDescription = styled(TextBlock).attrs(() => ({
  color: colors.smoke,
  styleType: 'medium',
}))``;

export const PersonalLedgerTableRow = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;
  padding: 1em;
  border-bottom: 1px solid ${colors.silt};
`;

export const ConfirmationModalLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
`;

export const ConfirmationModalHeader = styled.div`
  color: ${colors.cloud};
`;

export const ConfirmationModalControls = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
